module.exports = __webpack_public_path__ + "img/9.9346d98c.png";